import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { SelectLanguage } from '../../../state/language/language.action';
import { LanguageState } from '../../../state';
import { Logging } from '../../../services/logging/logging.service';
import { DeviceService } from '../../../services/ha-cuss/device.service';
import { locatedPnr } from '../../../services/emitters/session-event-emitters';
import { HaCussService } from '../../../services/ha-cuss/ha-cuss.service';
import { Router } from '@angular/router';
import { RoutingService } from '~app/services/routing/routing.service';

@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.scss'],
})
export class ChangeLanguageComponent implements OnInit, OnDestroy {
  constructor(
    private store: Store<LanguageState>,
    private logging: Logging,
    private router: Router,
    public deviceService: DeviceService,
    public haCussService: HaCussService,
    private routingService: RoutingService
  ) {}

  ngOnInit() {
    this.logging.infoUiChangeLanguageDisplayed(0);
    this.deviceService.disableLookupDevices();
  }

  ngOnDestroy(): void {
    locatedPnr
      .subscribe((value) => {
        if (value) {
          return;
        } else {
          this.haCussService.enableLookupDevices();
        }
      })
      .unsubscribe();
  }

  selectLang(lang: string) {
    this.logging.infoUiChangeLanguageSelected(lang, 0);
    this.store.dispatch(new SelectLanguage(lang));
    this.goBack();
  }

  goBack() {
    this.router.navigate([this.routingService.getPrevCheckInRoute()]);
  }

  onGoBackClick() {
    this.logging.infoUiChangeLangPageGoBack(0);
    this.goBack();
  }
}
